(() => {
  const sticky = document.querySelector('[data-cb-sticky-purchase]');
  const section = document.querySelector('#MainContent .main-product-section');
  const header = document.querySelector('.header-group-sticky');
  if (section && header) {
    const updateHeaderHeight = () => section.style.setProperty('--cb-header-height', `${header.getBoundingClientRect().height}px`);
    new ResizeObserver(updateHeaderHeight).observe(header);
    updateHeaderHeight();
  }
  const source = section?.querySelector('#add_to_cart,.cryo-bundle-product__button');
  if (!sticky || !source) return;
  const price = sticky.querySelector('[data-cb-sticky-price]');
  const button = sticky.querySelector('[data-cb-sticky-submit]');
  let originalVisible = true;
  let frame = null;
  const update = () => {
    frame = null;
    const variant = section.querySelector('.product-variant-tab.active');
    const subscribed = section.querySelector('.purchase_option_subscribe:checked');
    const plan = variant?.querySelector(subscribed ? '.subscribe-block' : '.one-time-block');
    const currentPrice = section.querySelector('[data-bundle-price]') || Array.from(plan?.querySelectorAll('.smartrr-subscribe-price') || []).find(element => element.getClientRects().length && element.textContent.trim());
    const amount = currentPrice?.textContent.trim().replace(/\s+/g, ' ') || '';
    const label = source.value || source.textContent.trim();
    price.textContent = amount;
    button.textContent = label;
    button.disabled = source.disabled || source.getAttribute('aria-disabled') === 'true' || source.getAttribute('aria-busy') === 'true';
    sticky.hidden = originalVisible || !amount;
  };
  const schedule = () => {
    if (frame === null) frame = requestAnimationFrame(update);
  };
  button.addEventListener('click', () => {
    if (!button.disabled) source.click();
  });
  const visibility = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.target === source) {
        originalVisible = entry.isIntersecting;
        schedule();
      } else {
        document.body.classList.toggle('cb-product-buybox-visible', entry.isIntersecting);
      }
    });
  });
  visibility.observe(source);
  visibility.observe(section.querySelector('.product__info-container'));
  new MutationObserver(schedule).observe(section, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class','style','disabled','aria-disabled','aria-busy','value']
  });
  section.addEventListener('change', schedule);
  update();
})();
